import { Button, Form } from 'antd';
import React, { useState } from 'react';
import { useForm, withForm } from 'react-antd-formutil';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { CardButtonWrap } from 'components/Card';
import Debug from 'components/Debug';
import Password from 'components/forms/Password';
import Toast from 'components/Toast';
import Track from 'components/Track';
import { getStep } from 'modules/Security/components/Steps';
import APP from 'stores/APP';
import { eventName, eventType } from '../../../../helper';
import store from '../../store';

interface ChangeModuleProps {
    type: 'password' | 'upgradePassword';
}

const ChangePwd: React.FC<ChangeModuleProps> = ({ type }) => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const $formutil = useForm<{ login_password: string }>();

    const submit = async () => {
        const { $params, $invalid, $getFirstError, $batchDirty } = $formutil;

        if ($invalid) {
            Toast.show($getFirstError());
            $batchDirty(true);
        } else {
            setLoading(true);

            try {
                const params: any = {
                    ...$params,
                    verify_token: (location.state as any)?.verify_token || ''
                };

                delete params.confirm_password;

                if (type === 'upgradePassword') {
                    await store.updatePassword(params);
                } else {
                    await store.modifySetting('login_password', params);
                }

                APP.trackEvent('安全中心', eventType[type], `${eventName[type]}_设置新密码`);

                const currentStep = getStep(location.pathname);

                // 跳转下一步时step：修改密码时为4，更新密码时为3
                navigate(`../${currentStep + 1}`);
            } catch (err) {
                if (err.error_code === 11084) {
                    // 操作时长过长
                    navigate('../1');
                }

                Toast.show(err);
            }

            setLoading(false);
        }
    };

    const { $params, $invalid } = $formutil;

    if (!location?.state) {
        return <Navigate to="../1" replace />;
    }

    return (
        <Form onFinish={submit} layout="vertical">
            <Password />
            <CardButtonWrap>
                <Track eventModel="安全中心" eventType={eventType[type]} eventName={`${eventName[type]}_下一步2`}>
                    <Button
                        block
                        type="primary"
                        size="large"
                        className="verify-identify-btn"
                        loading={loading}
                        disabled={$invalid}
                        htmlType="submit">
                        {__('下一步')}
                    </Button>
                </Track>
            </CardButtonWrap>
            <Debug data={$params} />
        </Form>
    );
};

export default withForm(ChangePwd);
